import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { EntityOrderedRequestParameters, EntityPagedRequestParameters, MessageChannelService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { ProtocoloArquivo, STATUS_PROTOCOLO, TIPO_PROTOCOLO } from 'src/app/model/protocolo-arquivo.model';
import { FileUtilsService } from 'src/app/shared/file-utils.service';
import { ProtocoloArquivoService } from 'src/app/shared/services/protocolo-arquivo.service';


@Component({
    selector: 'app-protocolo-renuncia-listagem',
    templateUrl: './protocolo-renuncia-listagem.component.html',
    styleUrls: ['./protocolo-renuncia-listagem.component.scss'],
    standalone: false
})
export class ProtocoloRenunciaListagemComponent implements OnInit, OnChanges {

   
    @Input() public cnpjAgente: string;
    @Input() public protocolos: ProtocoloArquivo[];
    @Input() public exibirComboTipoArquivo:boolean = false;
    @Input() public atributosPaginacao: EntityPagedRequestParameters;
    @Input() public formatoArquivo: string;
    @Output() public aoMudarPagina: EventEmitter<EntityPagedRequestParameters> = new EventEmitter<EntityPagedRequestParameters>();
    @Output() public exportarProtocolosRenuncia: EventEmitter<any> = new EventEmitter<any>();
    public opcoesPaginacao: number[];
    public atributosOrdenacao: EntityOrderedRequestParameters;

    public protocolosPaginados: ProtocoloArquivo[];
    private protocolosTemp: ProtocoloArquivo[];
    private tiposProtocolo = TIPO_PROTOCOLO;
    listagemExibida: ProtocoloArquivo[] = [];

   
    constructor(
        private fileUtils: FileUtilsService, 
        private protocoloService: ProtocoloArquivoService
        ) { }

    ngOnInit(): void {
        if (!this.atributosOrdenacao){
            this.atributosOrdenacao = {
                atributo: '',
                sentido: 'asc'
            }
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.pesquisar(this.atributosPaginacao);
    }

    mudancaPagina(novaPagina: EntityPagedRequestParameters) {
        this.atributosPaginacao = novaPagina;
        this.aoMudarPagina.emit(novaPagina);
      }

    mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
        this.atributosOrdenacao = novaOrdenacao;
        this.pesquisarOrdenacao(this.atributosOrdenacao);
        this.pesquisar(this.atributosPaginacao);
    }

    pesquisarOrdenacao(ord: EntityOrderedRequestParameters) {
        this.protocolos.sort((a, b) => {
            if (ord.sentido === 'asc') {
                return this.compara(a, b, ord.atributo);
            } else {
                return -1 * this.compara(a, b, ord.atributo);
            }
        });
    }
    obterTipoProtocolo(codigo:string):string{
        return this.tiposProtocolo.filter(p=> p.codigo.includes(codigo))[0].descricao;
    }

    private compara(a, b, atributo): number {
        if (this.fetchFromObject(a, atributo) === this.fetchFromObject(b, atributo)) {
            return 0;
        } else {
            if (this.fetchFromObject(a, atributo) > this.fetchFromObject(b, atributo)) {
                return 1;
            } else {
                return -1;
            }
        }
    }

    private fetchFromObject(obj, prop) {
        if (typeof obj === 'undefined') {
            return false;
        }

        const _index = prop.indexOf('.');
        if (_index > -1) {
            return this.fetchFromObject(obj[prop.substring(0, _index)], prop.substr(_index + 1));
        }

        return obj[prop];
    }

    private pesquisar(pesq: EntityPagedRequestParameters) {
        this.protocolosTemp = this.protocolos;
        this.protocolosPaginados = this.protocolosTemp.slice(0, pesq.pageSize);
     }

    downloadArquivoEnvio(idProtocoloArquivo: string) {
      if (this.formatoArquivo == 'csv') {
        this.protocoloService.getArquivoEnvioCsv(idProtocoloArquivo).subscribe((conteudoArquivo) => {
            this.fileUtils.exportarArquivo('Arquivo_envio_' + idProtocoloArquivo + '.csv',
                conteudoArquivo, FileUtilsService.TEXT_CSV);
        });
      }
      else {
        this.protocoloService.getArquivoEnvio(idProtocoloArquivo).subscribe((conteudoArquivo) => {
            this.fileUtils.exportarArquivo('Arquivo_envio_' + idProtocoloArquivo + '.json',
                JSON.stringify(conteudoArquivo), FileUtilsService.APPLICATION_JSON);
        });
      }

    } 

    downloadArquivoResposta(idProtocoloArquivo: string) {
      if (this.formatoArquivo == 'csv') {
        this.protocoloService.getArquivoRespostaCsv(idProtocoloArquivo).subscribe((conteudoArquivo) => {
          this.fileUtils.exportarArquivoUTF8('Arquivo_resposta_' + idProtocoloArquivo + '.CSV',
              conteudoArquivo, FileUtilsService.TEXT_CSV);
        });
      }
      else {
        this.protocoloService.getArquivoResposta(idProtocoloArquivo).subscribe((conteudoArquivo) => {
            this.fileUtils.exportarArquivo('Arquivo_resposta_' + idProtocoloArquivo + '.json',
              JSON.stringify(conteudoArquivo), FileUtilsService.APPLICATION_JSON);
          });
      }
    } 

    obterLabelStatusProtocolo(statusProtocolo: string) {
        return STATUS_PROTOCOLO.find(status => status.codigo === statusProtocolo).label;
    }

    btnExportarProtocolosRenuncia() {
        this.exportarProtocolosRenuncia.emit(null);
      }
    
    
}
